import { render, staticRenderFns } from "./cusBtn1.vue?vue&type=template&id=57eb56b8&scoped=true"
import script from "./cusBtn1.vue?vue&type=script&lang=js"
export * from "./cusBtn1.vue?vue&type=script&lang=js"
import style0 from "./cusBtn1.vue?vue&type=style&index=0&id=57eb56b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57eb56b8",
  null
  
)

export default component.exports